class ExtendableError extends Error {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = (new Error(message)).stack;
    }
  }
}

// now I can extend

export default class BobTVError extends ExtendableError {
    constructor(message) {
        super(message);
        this.bobtv = true;

        if (typeof message === 'object') {
            let messages = [];
            for (let name in message) messages.push(message[name]);

            this.message = messages.join('\n');
            this.messages = message;
        }
    }
}


// WEBPACK FOOTER //
// ./src/backend-helpers/error.js